<template>
    <v-app>
      <v-main>
        <v-container  fluid>
          <v-row justify="center" align="center">
            <v-col cols="12" md="8">
                  <v-empty-state
                    headline="Whoops, 404"
                    title="Page not found"
                    text="The page you were looking for does not exist"
                    icon="mdi mdi-alert-outline"
                    ></v-empty-state>

                  <div class="center pt-4">
                    <v-btn text color="primary" @click="$router.go(-1)">Back page</v-btn>
                  </div>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </template>
  
  <script>
  export default {
    created() {
      // Optionally, add any data fetching or other logic here
    },
    computed:{
      frontendBaseUrl(){
        return this.$store.getters.frontendBaseUrl;
      }
    }
  };
  </script>
  
  <style scoped>
  .title {
    font-size: 28px;
    font-weight: 500;
    margin-bottom: 16px;
  }
  .mt-5{
    margin-top: 20px;
  }
  .image-not-found{
    height: 300px;
    width:200px;
  }
  </style>
  